<template>
  <div class="footer border-top" id="footer">
    <div class="footer-first">
      <i class="iconfont">&#xe66e;</i>
      <p>首页</p>
    </div>
    <router-link tag="div" to="/category">
      <i class="iconfont">&#xe6a6;</i>
      <p>分类</p>
    </router-link>
    <router-link tag="div" to="/shopping">
      <i class="iconfont">&#xe603;</i>
      <p>购物车</p>
    </router-link>
    <router-link tag="div" to="/me">
      <i class="iconfont">&#xe6ad;</i>
      <p>我的</p>
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'HomeFooter'
}
</script>

<style scoped>
.footer{ display: flex; justify-content: space-around; text-align: center; position: fixed; left: 0; right: 0; bottom: 0; background-color: #fff; color: #575757;}
.footer p{ font-size: 12px; color: #575757;}
.footer .iconfont{ font-size: 20px; color: #575757;}
.footer .footer-first,.footer .footer-first p{ color: #e41436;}
.footer .footer-first,.footer .footer-first .iconfont{ color: #e41436;}
.footer div{ margin: 10px 0;}
</style>



// WEBPACK FOOTER //
// src/pages/index/components/Footer.vue